import {pageInfo,update,add,getDetailById,edit} from '../api';
import {plant,toxin} from '../../../../../api'
import {Message} from 'element-ui';

const plantToxin = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    updateObj: null,
    plantObj: null,
    toxinObj: null,
    addObj: null,
    detailObj: null,
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [true]}));
    },
    PLANT(state, data) {
      state.plantObj = data;
    },
    UPDATE(state, data){
      state.updateObj = data;
    },
    TOXIN(state, data){
      state.toxinObj = data;
    },
    ADD(state,data){
      state.addObj = data;
    },
    EDIT(state,data){
      state.editObj = data;
    },
    GET_DETAIL_BY_ID(state,data){
      state.detailObj = data;
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    async update({commit}, obj){
      let resp = await update(obj);
      commit('UPDATE', resp);
    },
    async toxin({commit}, obj){
      let resp = await toxin(obj);
      commit('TOXIN', resp);
    },
    async add({commit}, obj){
      let resp = await add(obj);
      commit('ADD',resp);
    },
    async edit({commit}, obj){
      let resp = await edit(obj);
      commit('EDIT',resp);
    },
    async getDetailById({commit}, obj){
      let resp = await getDetailById(obj);
      commit('GET_DETAIL_BY_ID',resp);
    }
  }
}
export default plantToxin



// WEBPACK FOOTER //
// ./src/page/md/runMaintain/plantToxin/store/plantToxin.store.js